import React, { useContext } from 'react';
import { translate } from '@utils/i18n';
import { Controller, useFormContext } from 'react-hook-form';
import { RecurrenceEndType } from '@features/Modals/NewGenericEventModal/constants';
import { DatePicker } from '@progress/kendo-react-dateinputs';
import { transformDayJstoDate } from '@utils/dateUtils';
import { dateClient } from '@utils/date-client';
import { TimeZoneContext } from '@contexts/timezone-context';
function RecurUntilSelector() {
    const namespace = 'features.modals.new_generic_event_modal.advanced_section.recurrence.recur_until_selector';
    const { timeZonesMapping } = useContext(TimeZoneContext);
    const { control, watch } = useFormContext();
    const formValues = watch();
    const handleDateChange = (field, e) => {
        const newDate = e.value;
        if (!newDate)
            return;
        const date = dateClient(newDate)
            .tz(timeZonesMapping[formValues.timeZone])
            .year(newDate.getFullYear())
            .month(newDate.getMonth())
            .date(newDate.getDate())
            .hour(0)
            .minute(0)
            .second(0)
            .millisecond(0);
        field.onChange(date);
    };
    return (React.createElement("div", { className: 'recurrenceRadioGroup' },
        React.createElement("span", { className: 'qmb-label--required' }, translate('when_recurrence_end', { namespace })),
        React.createElement(Controller, { name: "recurrence.endType", control: control, render: ({ field }) => (React.createElement("label", { className: "qmb-radio recurrenceRadio" },
                React.createElement("input", { type: "radio", name: field.name, value: RecurrenceEndType.After_occurrences, checked: field.value === RecurrenceEndType.After_occurrences, onChange: field.onChange }),
                translate(RecurrenceEndType.After_occurrences, { namespace }))) }),
        formValues.recurrence.endType === RecurrenceEndType.After_occurrences && (React.createElement(Controller, { name: "recurrence.maxOccurrences", control: control, render: ({ field }) => (React.createElement("div", { className: "recurrenceRadioOption" },
                React.createElement("input", { type: "number", min: "1", max: "100", value: field.value, onChange: (e) => field.onChange(e.target.value || 1), className: "form-control form-control-sm", style: { width: '70px' } }),
                React.createElement("span", null, translate('occurrences', { namespace })))) })),
        React.createElement(Controller, { name: "recurrence.endType", control: control, render: ({ field }) => (React.createElement("label", { className: "qmb-radio recurrenceRadio" },
                React.createElement("input", { type: "radio", name: field.name, value: RecurrenceEndType.On_date, checked: field.value === RecurrenceEndType.On_date, onChange: field.onChange }),
                translate(RecurrenceEndType.On_date, { namespace }))) }),
        formValues.recurrence.endType === RecurrenceEndType.On_date && (React.createElement(Controller, { name: "recurrence.endDate", control: control, render: ({ field }) => (React.createElement("div", { className: 'recurrenceRadioOption' },
                React.createElement(DatePicker, { width: 200, min: new Date(), max: dateClient().add(7, 'year').toDate(), value: transformDayJstoDate(field.value), onChange: (e) => handleDateChange(field, e) }))) }))));
}
export default RecurUntilSelector;
